import { TransformedSuperGridColDef } from '@aleph/supergrid';
import { FileType } from 'rsuite/Uploader';
import { useMutation } from '@apollo/client';
import { MediaInput, UploadRedditMediaDocument } from 'wb-reddit/graphql/generated';
import { RedditLevel } from 'wb-reddit/app/routes/superGrid/utils';
import { getFileNameExtension, supportedImageFormats } from 'wb-reddit/app/routes/superGrid/cellRenderers/media';
import { NoValuePlaceholder, UploadCellComponent } from '@aleph/shared-components';
import { ICellRendererParams } from 'ag-grid-community';
import { captureException } from '@sentry/react';

const RedditThumbnailCellRenderer = (params: ICellRendererParams & { disabled?: boolean }) => {
	const colDef = params.colDef as TransformedSuperGridColDef<RedditLevel>;
	const [uploadMedia, { loading }] = useMutation(UploadRedditMediaDocument);

	const onUpload = async (files: FileType[]) => {
		const fileExtension = getFileNameExtension(files[0].name || '');

		let media: MediaInput = {
			image: files[0].blobFile,
		};

		if (!supportedImageFormats.includes(fileExtension)) {
			params?.setValue?.(null);

			return;
		}
		media = {
			image: files[0].blobFile,
		};

		try {
			const { data: uploadMediaData } = await uploadMedia({
				variables: {
					media,
					clientId: params.data.parent?.parent?.parent?.clientId,
				},
			});

			params?.setValue?.(uploadMediaData?.uploadMedia);
		} catch (e) {
			captureException(e);
		}
	};

	if (params.data.isCreate || (params.disabled)
		|| (colDef?.level && colDef.level !== params.data.level)
		|| params.data.creativeType === 'TEXT') {
		return <NoValuePlaceholder />;
	}

	if (!params.value) {
		return (
			<UploadCellComponent
				loading={loading}
				mediaUrl={params.data.mediaThumbnail}
				mediaName={params.data.mediaName}
				onUpload={onUpload}
				accept={supportedImageFormats.map((format) => `image/${format}`).join(', ')}
			/>
		);
	}

	return (
		<div className="flex gap-[8px] items-center h-full">
			<img
				alt="media"
				className="h-full aspect-square object-cover"
				src={params.value ?? ''}
			/>

			<div>
				{params.value}
			</div>
		</div>
	);
};

export default RedditThumbnailCellRenderer;
